export type OrderPaymentOutcome = 'succeeded' | 'failed'

/** Payload сокета order:payment_status с сервера */
export type OrderPaymentStatusPayload = {
  id: number
  pizzeria_id: number
  total_price: number
  order_number?: string | number | null
  outcome: OrderPaymentOutcome
}

/**
 * Номер заказа для текста (внешний или id).
 * @param payload — данные события оплаты
 */
export const getOrderPaymentDisplayNumber = (
  payload: Pick<OrderPaymentStatusPayload, 'id' | 'order_number'>
): string => {
  const orderNumber = payload?.order_number
  if (orderNumber != null && String(orderNumber).trim() !== '') {
    return String(orderNumber)
  }
  return String(payload.id)
}

/**
 * Текст уведомления об оплате / ошибке оплаты.
 * @param payload — данные события
 */
export const formatOrderPaymentNotificationText = (
  payload: OrderPaymentStatusPayload
): { title: string; body: string } => {
  const displayNumber = getOrderPaymentDisplayNumber(payload)
  const amountLabel = `${payload.total_price} ₽`

  if (payload.outcome === 'succeeded') {
    return {
      title: 'Оплата прошла',
      body: `Заказ ${displayNumber} на сумму ${amountLabel} успешно оплачен.`,
    }
  }

  return {
    title: 'Ошибка оплаты',
    body: `Ошибка оплаты заказа ${displayNumber} на сумму ${amountLabel}.`,
  }
}
